export default function () {
  return {
    actions: [],
    models: []
  }
}
